module.exports = "::ng-deep .holidays-edit-component .mat-form-field {\n  width: 100%;\n}\n"